import { get, isEmpty } from 'lodash'
import type { OfferRecipients } from '../../../modules/privateOffer/types'

export const flyoutFormDebounceTime = 300

export const getRecipientErrMapping = (
  recipient: OfferRecipients[],
  recipientsError: Record<string, unknown>[]
) => {
  return recipient.map((recipient, index) => {
    const firstNameError = get(
      recipientsError,
      [index, 'firstName'],
      ''
    ) as string
    const lastNameError = get(
      recipientsError,
      [index, 'lastName'],
      ''
    ) as string
    const emailError = get(recipientsError, [index, 'email'], '') as string
    return {
      ...recipient,
      firstNameHasError: !isEmpty(firstNameError),
      lastNameHasError: !isEmpty(lastNameError),
      emailHasError: !isEmpty(emailError),
      firstNameError,
      lastNameError,
      emailError,
    }
  })
}
